import React from 'react';
import ReactDOM from 'react-dom';
import { MdClose } from 'react-icons/md';
import { toastAlert } from 'src/utils/toastAlert';

interface Props {
  onClick: any;
  children: React.ReactNode;
  title: any;
  modalSize?: string;
  errorMsg?: string;
  className?: string;
  hideCross?: boolean;
  crossContent?: string;
  isDelete?: boolean;
}

const Modal: React.FC<Props> = ({
  className,
  title,
  isDelete,
  children,
  onClick,
  modalSize,
  errorMsg,
  crossContent,
  hideCross,
}) => {
  return ReactDOM.createPortal(
    <React.Fragment>
      <div
        className={
          'fixed top-0 left-0 right-0 bottom-0 z-0 bg-[#000]   bg-opacity-50 h-auto'
        }
        onClick={onClick}
      />
      <div
        className={`${
          modalSize ? `w-[${modalSize}%]` : 'w-[388px]'
        } max-h-[80vh] overflow-y-auto fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  p-6 rounded-xl bg-pure-white mx-3 ${className}`}
      >
        <div className="flex items-center justify-between">
          <h5 className="text-xl font-semibold text-text-black font-Outfit leading-[30px]">
            {title}
          </h5>

          {hideCross ? (
            ''
          ) : crossContent ? (
            <div className="text-base font-semibold text-text-black font-Outfit  min-w-[90px] flex justify-end">
              {crossContent}
            </div>
          ) : (
            <MdClose onClick={onClick} size={25} />
          )}
        </div>
        <div className="my-3">
          {errorMsg && (
            <p className="text-xl text-warning font-semibold text-center py-4">
              {errorMsg}
            </p>
          )}
          {children}
        </div>
      </div>
      <div className="border-bottom" />
    </React.Fragment>,
    document.getElementById('portal') as HTMLElement
  );
};

export default Modal;
